import { FC } from 'react';
import { Card } from '../ui/card';
import { AvatarUpload } from '../settings/AvatarUpload';
import { useProfile } from '@/hooks/useProfile';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

export const CommunityProfile: FC = () => {
  const { userProfile, isLoading, refetch } = useProfile();

  const updateAvatar = async (avatarUrl: string) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user?.id) {
        throw new Error('No se encontró el ID del usuario');
      }

      const { error } = await supabase
        .from('profiles')
        .update({
          avatar_url: avatarUrl,
          updated_at: new Date().toISOString(),
        })
        .eq('id', user.id);

      if (error) throw error;

      // Recargar el perfil
      await refetch();
    } catch (error) {
      console.error('Error updating avatar:', error);
      throw error;
    }
  };

  if (isLoading) {
    return (
      <Card className="p-4 flex justify-center items-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </Card>
    );
  }

  if (!userProfile) return null;

  return (
    <Card className="p-6 bg-white/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4">
        <h3 className="font-semibold text-lg">Tu Perfil</h3>
        <AvatarUpload
          url={userProfile.avatar_url}
          onUpload={updateAvatar}
          name={userProfile.student_name || 'U'}
        />
        <div className="text-center">
          <p className="font-medium">{userProfile.student_name}</p>
          <p className="text-sm text-gray-500">Estudiante</p>
        </div>
      </div>
    </Card>
  );
};
